import { BottomSheet, Text, type UseModalState } from "@clipboard-health/ui-components";
import { BottomSheetHeader } from "@src/appV2/redesign/components/BottomSheetHeader";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";

interface RescheduleOrCancelInterviewBottomSheetProps {
  modalState: UseModalState;
  onReschedule: () => void;
  onCancel: () => void;
}

export function RescheduleOrCancelInterviewBottomSheet(
  props: RescheduleOrCancelInterviewBottomSheetProps
) {
  const { modalState, onReschedule, onCancel } = props;

  return (
    <BottomSheet
      modalState={modalState}
      footer={
        <DialogFooter orientation="vertical">
          <Button fullWidth variant="outlined" size="large" onClick={onReschedule}>
            Reschedule interview
          </Button>
          <Button fullWidth variant="destructive" size="large" onClick={onCancel}>
            Cancel interview
          </Button>
        </DialogFooter>
      }
      header={<BottomSheetHeader onClose={modalState.closeModal} />}
    >
      <Text variant="h3" textAlign="center">
        What would you like to do?
      </Text>
    </BottomSheet>
  );
}
